import { ID } from './id';

export enum TaskActionType {
  GoalTimeslot = 'goal-timeslot',
  LifeAreaTimeslot = 'life-area-timeslot',
  TagTimeslot = 'tag-timeslot',
  SmartListTimeslot = 'smart-list-timeslot',
}

export type TaskActionGoal = {
  type: TaskActionType.GoalTimeslot;
  meta: { id: ID };
};

export type TaskActionLifeArea = {
  type: TaskActionType.LifeAreaTimeslot;
  meta: { id: ID };
};

export type TaskActionTag = {
  type: TaskActionType.TagTimeslot;
  meta: { id: ID };
};

export type TaskActionSmartList = {
  type: TaskActionType.SmartListTimeslot;
  meta: { id: ID };
};

// Generic TaskAction type as a union of specific action types
export type TaskAction =
  | TaskActionGoal
  | TaskActionLifeArea
  | TaskActionTag
  | TaskActionSmartList;
